import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Doctos = () => {
    const rawHtml = `
		<style>
			.form-control::placeholder {
				color: white !important;
				opacity: 0.7;
			}
			.form-control:-ms-input-placeholder {
				color: white !important;
				opacity: 0.7;
			}
			.form-control::-ms-input-placeholder {
				color: white !important;
				opacity: 0.7;
			}
			/* Dropdown Menu Styles */
			.menu-item.has-children {
				position: relative;
			}
			.menu-item.has-children:hover .sub-menu {
				display: block;
			}
			.sub-menu {
				display: none;
				position: absolute;
				top: 100%;
				left: 0;
				background: #fff;
				min-width: 200px;
				box-shadow: 0 2px 5px rgba(0,0,0,0.1);
				z-index: 1000;
				border-radius: 4px;
				padding: 8px 0;
			}
			.sub-menu .menu-item {
				padding: 0;
				list-style: none !important;
				margin-left: 0 !important;
			}
			.sub-menu .menu-link {
				padding: 8px 20px;
				color: #333;
				display: block;
				transition: all 0.3s ease;
			}
			.sub-menu .menu-link:hover {
				background: #0A3C3F;
				color: #fff;
			}
			.sub-menu .menu-link div {
				font-size: 14px;
			}
			.sub-menu, .sub-menu .menu-item {
				list-style: none !important;
				padding-left: 0 !important;
				margin-left: 0 !important;
			}
		</style>
		<!-- stretched (body)
		============================================= -->
		<body class="stretched">

			<!-- Document Wrapper
			============================================= -->
			<div id="wrapper">

				<!-- Hero
				============================================= -->
				<section id="slider" class="slider-element include-header" style="background: linear-gradient(90deg, rgba(34, 193, 195, 0.06), rgba(253, 187, 45, 0.1));">
					<div class="container mt-lg-6">
						<div class="row justify-content-between align-items-center py-lg-6 py-5">
							<div class="col-lg-5 mb-4 mb-lg-0">
								<img src="demos/doctors/images/icons/wave.svg" alt="..." class="position-absolute top-0 start-0 translate-middle d-none d-md-block" width="50">
								<h2 class="display-3 fw-bold color all-ts">Welcome to <span class="underliner nocolor viewport-detect" data-delay="1000">Rexroth</span> Nutriscience Pvt. Ltd.</h2>
								<p>Pioneering Excellence in Nutraceutical Innovation</p>
								<a href="/products" class="button py-3 px-4 bg-color-2 color h-bg-color h-text-light rounded mx-0">Explore Products<i class="bi-arrow-right ms-2 me-0"></i></a>
							</div>
							<div class="col-lg-6">
								<!-- Gallery -->
								<div class="row align-items-center g-4">
									<div class="col-6">
										<img src="https://i.pinimg.com/736x/2a/0a/0c/2a0a0c1e9f2df4591d14645aa2b39a28.jpg" alt="Image" class="object-cover rounded-6">
									</div>
									<div class="col-6">
										<img src="demos/doctors/images/hero/r2.jpg" alt="Image" class="object-cover rounded-6 mb-4">
										<img src="demos/doctors/images/hero/r3.jpg" alt="Image" class="object-cover rounded-6">
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				<!-- Content
				============================================= -->
				<section id="content">
					<div class="content-wrap py-0">

						<div id="section-search" class="section my-0 bg-transparent">
							<div class="container py-lg-5">
								<div class="row justify-content-center">
									<div class="col-md-9 text-center">
										<h2 class="display-4 text-rotater" data-separator="," data-rotate="fadeInUpSmall faster bg-color-2 bg-opacity-50 px-2" data-speed="3500">Your Trusted Partner <span class="t-rotate d-inline nocolor morphtext"></span></h2>
									</div>
								</div>
								<div class="position-relative bg-contrast-0 rounded mt-3">
									<div class="row flex-column flex-lg-row align-items-center">
										<div class="col-lg-12">
											<div class="p-3 ps-0">
												<div class="row align-items-center">
													<div class="col-lg-8">
														<div class="bg-color-2 bg-opacity-10 rounded-3 p-3 mb-3">
															<p class="lead mb-0">At Rexroth Nutriscience Pvt. Ltd., we're revolutionizing the nutraceutical industry through cutting-edge science and unwavering commitment to quality. Our state-of-the-art manufacturing facility combines pharmaceutical-grade precision with innovative research to create products that truly make a difference.</p>
														</div>
														
														<div class="row g-3 mt-3">
															<div class="col-md-4">
																<div class="d-flex align-items-center bg-white rounded-3 p-2 shadow-sm hover-float">
																	<div class="bg-color-2 bg-opacity-10 rounded-circle p-2 me-2">
																		<img src="https://cdn-icons-png.flaticon.com/512/1995/1995571.png" alt="Science" class="w-100 h-100" style="max-width: 28px;">
																	</div>
																	<div>
																		<h5 class="mb-1 fs-6">Science-Driven</h5>
																		<p class="mb-0 small text-muted">Advanced Formulations</p>
																	</div>
																</div>
															</div>
															<div class="col-md-4">
																<div class="d-flex align-items-center bg-white rounded-3 p-2 shadow-sm hover-float">
																	<div class="bg-color-2 bg-opacity-10 rounded-circle p-2 me-2">
																		<img src="https://cdn-icons-png.flaticon.com/512/1995/1995572.png" alt="Quality" class="w-100 h-100" style="max-width: 28px;">
																	</div>
																	<div>
																		<h5 class="mb-1 fs-6">Nutraceuticals</h5>
																		<p class="mb-0 small text-muted">Precision Quality</p>
																	</div>
																</div>
															</div>
															<div class="col-md-4">
																<div class="d-flex align-items-center bg-white rounded-3 p-2 shadow-sm hover-float">
																	<div class="bg-color-2 bg-opacity-10 rounded-circle p-2 me-2">
																		<img src="https://cdn-icons-png.flaticon.com/512/1995/1995573.png" alt="Natural" class="w-100 h-100" style="max-width: 28px;">
																	</div>
																	<div>
																		<h5 class="mb-1 fs-6">Natural</h5>
																		<p class="mb-0 small text-muted">Wellness Solutions</p>
																	</div>
																</div>
															</div>
														</div>

														<div class="bg-white rounded-3 p-3 mt-3 shadow-sm">
															<p class="mb-0">Our comprehensive range of nutraceutical solutions is designed to empower individuals to achieve optimal health naturally. From immunity support to mental clarity, gut health to metabolic balance, every Rexroth product is crafted with pure ingredients and backed by rigorous quality control.</p>
														</div>
													</div>
													<div class="col-lg-4 d-none d-lg-block">
														<div class="position-relative">
															<div class="bg-white rounded-3 p-2 mb-2 shadow-sm hover-float">
																<img src="images/facility.jpg" alt="Laboratory" class="rounded-2 w-100" style="height: 150px; object-fit: cover;">
																<div class="d-flex align-items-center mt-2">
																	<i class="bi-building-fill me-2 color-yellow"></i>
																	<h6 class="mb-0 fs-6">State-of-the-Art Facility</h6>
																</div>
															</div>
															<div class="bg-white rounded-3 p-2 mb-2 shadow-sm hover-float">
																<img src="images/research.jpeg" alt="Research" class="rounded-2 w-100" style="height: 150px; object-fit: cover;">
																<div class="d-flex align-items-center mt-2">
																	<i class="bi-gear-fill me-2 color-yellow"></i>
																	<h6 class="mb-0 fs-6">Advanced Research</h6>
																</div>
															</div>
															<div class="bg-white rounded-3 p-2 shadow-sm hover-float">
																<img src="images/quality.jpeg" alt="Quality" class="rounded-2 w-100" style="height: 150px; object-fit: cover;">
																<div class="d-flex align-items-center mt-2">
																	<i class="bi-shield-check me-2 color-yellow"></i>
																	<h6 class="mb-0 fs-6">Quality Assurance</h6>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="section mt-0">
							<div class="container">
								<div class="row justify-content-center mb-4">
									<div class="col-md-9 text-center">
										<h2 class="display-4 mb-3">Why Choose Rexroth?</h2>
										<p>Excellence in every aspect of nutraceutical manufacturing</p>
									</div>
								</div>
								<div class="row row-cols-xl-5 row-cols-lg-4 row-cols-sm-2 row-cols-1 services-categories g-4 align-items-stretch">
									<div class="services-category-item">
										<a href="#" class="card border-0 rounded-6">
											<div class="card-body justify-content-center align-items-center px-4 py-5 text-center">
												<h4 class="my-1">GMP-Certified</h4>
												<small class="text-smaller">World-class manufacturing standards</small>
											</div>
										</a>
									</div>

									<div class="services-category-item">
										<a href="#" class="card border-0 rounded-6">
											<div class="card-body justify-content-center align-items-center px-4 py-5 text-center">
												<h4 class="my-1">Clinical Research</h4>
												<small class="text-smaller">Scientifically validated formulations</small>
											</div>
										</a>
									</div>

									<div class="services-category-item">
										<a href="#" class="card border-0 rounded-6">
											<div class="card-body justify-content-center align-items-center px-4 py-5 text-center">
												<h4 class="my-1">Global Compliance</h4>
												<small class="text-smaller">FDA, FSSAI, EFSA certified</small>
											</div>
										</a>
									</div>

									<div class="services-category-item">
										<a href="#" class="card border-0 rounded-6">
											<div class="card-body justify-content-center align-items-center px-4 py-5 text-center">
												<h4 class="my-1">Innovation</h4>
												<small class="text-smaller">Cutting-edge wellness solutions</small>
											</div>
										</a>
									</div>

									<div class="services-category-item">
										<a href="#" class="card border-0 rounded-6">
											<div class="card-body justify-content-center align-items-center px-4 py-5 text-center">
												<h4 class="my-1">Sustainability</h4>
												<small class="text-smaller">Ethical sourcing and practices</small>
											</div>
										</a>
									</div>
								</div>
							</div>
						</div>

						<div class="section my-0 bg-transparent">
							<div class="container">
								<div class="row justify-content-center mb-5">
									<div class="col-md-9 text-center">
										<h2 class="display-4 mb-3">Our Product Range</h2>
										<p>Discover our comprehensive range of nutraceutical solutions</p>
									</div>
								</div>
								<div class="row row-cols-xl-4 row-cols-lg-3 row-cols-sm-2 row-cols-1 g-4">
									<div class="col">
										<div class="card border-0 rounded-6 h-100">
											<div class="card-body text-center p-4">
												<img src="images/dietary.jpg" alt="Dietary Supplements" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
												<h4 class="mb-2">Dietary Supplements</h4>
												<p class="mb-3 text-muted">Tablets & Capsules</p>
												<a href="/dietary-supplements" class="button button-small button-border button-rounded">View Products</a>
											</div>
										</div>
									</div>
									<div class="col">
										<div class="card border-0 rounded-6 h-100">
											<div class="card-body text-center p-4">
												<img src="images/syrups.jpg" alt="Syrups & Suspensions" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
												<h4 class="mb-2">Syrups & Suspensions</h4>
												<p class="mb-3 text-muted">Liquid Formulations</p>
												<a href="/syrups-and-suspensions" class="button button-small button-border button-rounded">View Products</a>
											</div>
										</div>
									</div>
									<div class="col">
										<div class="card border-0 rounded-6 h-100">
											<div class="card-body text-center p-4">
												<img src="images/gummies.jpeg" alt="Gummies" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
												<h4 class="mb-2">Gummies</h4>
												<p class="mb-3 text-muted">Chewable Supplements</p>
												<a href="/gummies" class="button button-small button-border button-rounded">View Products</a>
											</div>
										</div>
									</div>
									<div class="col">
										<div class="card border-0 rounded-6 h-100">
											<div class="card-body text-center p-4">
												<img src="images/effervescent.webp" alt="Effervescent Tablets" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
												<h4 class="mb-2">Effervescent Tablets</h4>
												<p class="mb-3 text-muted">Dissolvable Formulations</p>
												<a href="/effervescent-tablets" class="button button-small button-border button-rounded">View Products</a>
											</div>
										</div>
									</div>
									<div class="col">
										<div class="card border-0 rounded-6 h-100">
											<div class="card-body text-center p-4">
												<img src="images/fitness.jpg" alt="Fitness Supplements" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
												<h4 class="mb-2">Fitness Supplements</h4>
												<p class="mb-3 text-muted">Tablets & Capsules</p>
												<a href="/fitness-supplements-tablets" class="button button-small button-border button-rounded">View Products</a>
											</div>
										</div>
									</div>
									<div class="col">
										<div class="card border-0 rounded-6 h-100">
											<div class="card-body text-center p-4">
												<img src="images/fitness-powder.jpeg" alt="Fitness Supplements" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
												<h4 class="mb-2">Fitness Supplements</h4>
												<p class="mb-3 text-muted">Powders</p>
												<a href="/fitness-supplements-powders" class="button button-small button-border button-rounded">View Products</a>
											</div>
										</div>
									</div>
									<div class="col">
										<div class="card border-0 rounded-6 h-100">
											<div class="card-body text-center p-4">
												<img src="images/protein.jpeg" alt="Healthcare Protein" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
												<h4 class="mb-2">Healthcare Protein</h4>
												<p class="mb-3 text-muted">Protein Supplements</p>
												<a href="/healthcare-protein-supplements" class="button button-small button-border button-rounded">View Products</a>
											</div>
										</div>
									</div>
									<div class="col">
										<div class="card border-0 rounded-6 h-100">
											<div class="card-body text-center p-4">
												<img src="images/energy.webp" alt="Energy Drinks" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
												<h4 class="mb-2">Energy Drinks</h4>
												<p class="mb-3 text-muted">Sachets & Sticks</p>
												<a href="/energy-drink-and-sachets" class="button button-small button-border button-rounded">View Products</a>
											</div>
										</div>
									</div>
									<div class="col">
										<div class="card border-0 rounded-6 h-100">
											<div class="card-body text-center p-4">
												<img src="images/softgel.jpeg" alt="Softgel" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
												<h4 class="mb-2">Softgel</h4>
												<p class="mb-3 text-muted">Gelatin Capsules</p>
												<a href="/softgel-supplements" class="button button-small button-border button-rounded">View Products</a>
											</div>
										</div>
									</div>
									<div class="col">
										<div class="card border-0 rounded-6 h-100">
											<div class="card-body text-center p-4">
												<img src="images/beauty.webp" alt="Skin & Hair" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
												<h4 class="mb-2">Skin & Hair</h4>
												<p class="mb-3 text-muted">Beauty Supplements</p>
												<a href="/skin-and-hair-supplements" class="button button-small button-border button-rounded">View Products</a>
											</div>
										</div>
									</div>
									<div class="col">
										<div class="card border-0 rounded-6 h-100">
											<div class="card-body text-center p-4">
												<img src="images/cosmetic.jpg" alt="Cosmetic" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
												<h4 class="mb-2">Cosmetic</h4>
												<p class="mb-3 text-muted">Beauty Products</p>
												<a href="/cosmetics" class="button button-small button-border button-rounded">View Products</a>
											</div>
										</div>
									</div>
									<div class="col">
										<div class="card border-0 rounded-6 h-100">
											<div class="card-body text-center p-4">
												<img src="images/herbal.jpeg" alt="Herbal" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
												<h4 class="mb-2">Herbal</h4>
												<p class="mb-3 text-muted">Natural Products</p>
												<a href="/herbals" class="button button-small button-border button-rounded">View Products</a>
											</div>
										</div>
									</div>
									<div class="col">
										<div class="card border-0 rounded-6 h-100">
											<div class="card-body text-center p-4">
												<img src="images/other.jpeg" alt="Other Products" class="rounded-3 w-100 mb-4" style="height: 200px; object-fit: cover;">
												<h4 class="mb-2">Other Products</h4>
												<p class="mb-3 text-muted">Nutraceutical Solutions</p>
												<a href="/other-nutraceutical-products" class="button button-small button-border button-rounded">View Products</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="section bg-color dark my-0">
							<div class="container py-lg-5">
								<div class="row g-4 justify-content-around">
									<div class="col-md-3 col-6">
										<h3 class="display-3 text-white mb-1">100%</h3>
										<small class="color-2 text-uppercase ls-2 text-smaller">Quality Assured</small>
									</div>

									<div class="col-md-3 col-6">
										<h3 class="display-3 text-white mb-1">50+</h3>
										<small class="color-2 text-uppercase ls-2 text-smaller">Product Variants</small>
									</div>

									<div class="col-md-3 col-6">
										<h3 class="display-3 text-white mb-1">15+</h3>
										<small class="color-2 text-uppercase ls-2 text-smaller">Years Experience</small>
									</div>

									<div class="col-md-3 col-6">
										<h3 class="display-3 text-white mb-1">100%</h3>
										<small class="color-2 text-uppercase ls-2 text-smaller">Customer Satisfaction</small>
									</div>
								</div>
							</div>
						</div>

						<div class="section bg-transparent mt-0">
							<div class="container">
								<div class="row gy-4 justify-content-around align-items-center">
									<div class="col-md-5">
										<img src="demos/doctors/images/icons/wave.svg" alt="..." class="position-absolute top-0 start-0 translate-middle d-none d-md-block" width="36">
										<h2 class="display-4 mb-3">Ready to Partner with Us?</h2>
										<p class="">Let's build a healthier future together. Whether you're a distributor, healthcare provider, or wellness brand—we're here to support your mission with trusted nutraceutical innovation.</p>
										<!--<div class="widget subscribe-widget" data-loader="button">
											<div class="widget-subscribe-form-result"></div>
											<form id="widget-subscribe-form" action="include/subscribe.php" method="post" class="mb-0 d-flex bg-color-2 rounded-pill p-2 bg-opacity-50">
												<input type="email" id="widget-subscribe-form-email" name="widget-subscribe-form-email" class="form-control bg-transparent border-0 required email ps-3" placeholder="Your Email Address">
												<button class="button button-large rounded-pill m-0" type="submit">Contact Us</button>
											</form>
										</div>-->
									</div>
								</div>
							</div>
						</div>

						<!--<div class="section dark bg-color my-0">
							<div class="container">
								<div class="row align-items-center justify-content-between">
									<div class="col-md-4 mt-4">
										<img src="demos/doctors/images/icons/wave.svg" alt="..." class="position-absolute top-0 start-0 translate-middle d-none d-md-block" width="36">
										<h3 class="display-6">Get in touch with Us</h3>
										<p>Ready to explore our products or discuss partnership opportunities? We're here to help.</p>

										<div class="divider divider-xs fw-light font-body text-uppercase mb-5 op-05 ms-0" style="--cnvs-divider-border-color: rgba(var(--cnvs-contrast-rgb), 0.2)"><div class="divider-text">Or</div></div>

										<h3 class="fs-6 fw-light text-uppercase op-07 mb-2">Give us a Quick Call</h3>
										<h2 class="display-4">+91 9824239449</h2>
									</div>

									<div class="col-md-6">
										<div class="form-widget">
											<div class="form-result"></div>
											<form class="row mb-0" id="template-contactform" name="template-contactform" action="include/form.php" method="post">
												<div class="form-process">
													<div class="css3-spinner">
														<div class="css3-spinner-scaler"></div>
													</div>
												</div>

												<div class="col-12 form-group">
													<input type="text" id="template-contactform-name" name="template-contactform-name" value="" class="form-control border-form-control border-light border-opacity-50 py-3 required text-white" placeholder="Full Name..">
												</div>

												<div class="col-12 form-group">
													<input type="email" id="template-contactform-email" name="template-contactform-email" value="" class="email form-control border-form-control border-light border-opacity-50 py-3 required text-white" placeholder="Email Address..">
												</div>

												<div class="col-12 form-group">
													<input type="text" id="template-contactform-phone" name="template-contactform-phone" value="" class="form-control border-form-control border-light border-opacity-50 py-3 text-white" placeholder="Phone Number..">
												</div>

												<div class="col-12 form-group">
													<textarea class="required form-control border-form-control border-light border-opacity-50 py-3 text-white" id="template-contactform-message" name="template-contactform-message" rows="2" cols="30" placeholder="Type Your Message Here.."></textarea>
												</div>

												<div class="col-12 form-group">
													<button class="button button-large button-light h-text-dark h-bg-color-2 rounded ms-0 mt-3" type="submit" id="template-contactform-submit" name="template-contactform-submit" value="submit">Send Message</button>
												</div>
											</form>
										</div>
									</div>
								</div>
							</div>
						</div>-->
					</div>
				</section><!-- #content end -->

				<!-- Footer
				============================================= -->
			</div><!-- #wrapper end -->
		`;

    return (
        <>
            <Header />
            <div dangerouslySetInnerHTML={{ __html: rawHtml }} />
            <Footer />
        </>
    );
};

export default Doctos;
